// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M21 3V14.74L16.3 19.44H12.39L9.95 21.79H6.91V19.44H3V6.13L4.23 3ZM19.44 4.56H6.13V16.3H9.26V18.65L11.61 16.3H16.31L19.44 13.17ZM16.31 7.69V12.39H14.74V7.7ZM12.4 7.69V12.39H10.84V7.7Z"/>';

/** Twitch (social). */
const icon: IconData = {
  id: "twitch",
  name: "Twitch",
  category: "social",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M4.3 3H21V14.7L16.3 19.4H12.4L9.9 21.8H7V19.4H3V6.2ZM5 17.4H9V19.8H9.1L11.6 17.4H15.48L19 13.87V5H5ZM15 8H17V12.7H15ZM15 8H17V12.7H15ZM10 8H12V12.7H10Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M21 14.7L16.3 19.4H12.4L9.9 21.8H7V19.4H3V6.2L4.3 3H21Z"/></g><path d="M4.3 3H21V14.7L16.3 19.4H12.4L9.9 21.8H7V19.4H3V6.2ZM5 17.4H9V19.8H9.1L11.6 17.4H15.48L19 13.87V5H5ZM15 8H17V12.7H15ZM15 8H17V12.7H15ZM10 8H12V12.7H10Z"/>',
    },
  },
  animation: () => import("../animations/twitch.js"),
};

export default icon;
